import styled from 'styled-components';

export const Button = styled.button.attrs({
	disabled: props => props.disabled
})`
	height: 37px;
	border: 1px solid;
	border-radius: 14.5px;
	color: #04065a;
	font-family: GothamLight;
	font-size: 11px;
	background-color: #83BED3;
	cursor: pointer;
	transition-duration: .4s;
	padding-left: 17px;
	padding-right: 17px;
	
	border-color: ${props => props.borderColor ? props.borderColor : '#5A9AB0'}
	
	:hover {
		background-color: Transparent;
		border-color: ${props => props.hoverBorderColor ? props.hoverBorderColor : '#5A9AB0'}
		color: #FFFFFF
	}
	
	:disabled {
		background-color: #b8bbbc;
		cursor: unset;
		opacity: 0.6;
	}
`;


// WEBPACK FOOTER //
// ./src/common/components/Button.js